import { useNavigate } from 'react-router-dom';

import { VIEWPORT_HEIGHT } from 'coreOld/constants';
import { IFiltersProps } from 'coreOld/types';
import { useGetSupportRequest } from 'support/hooks';
import { editSupportRequestJobsPath } from 'support/routes/routePaths';

import RequestJobListView from './RequestJobListView';

interface IProps extends IFiltersProps {
  filtersConfig: unknown;
  requestId: number;
}

const RequestJobList = ({ filtersConfig, requestId }: IProps) => {
  const navigate = useNavigate();

  const {
    record: request,
    isLoading,
    isError,
    statusCode,
  } = useGetSupportRequest({
    id: requestId,
  });

  const onEditJobsClick = () => navigate(editSupportRequestJobsPath(requestId));

  return (
    <RequestJobListView
      request={request}
      filtersConfig={filtersConfig}
      onEditJobsClick={onEditJobsClick}
      isLoading={isLoading}
      isError={isError || !request}
      statusCode={statusCode}
      loaderMinHeight={VIEWPORT_HEIGHT}
    />
  );
};

export default RequestJobList;
